import { render, staticRenderFns } from "./SideNavBarQuestionLink.vue?vue&type=template&id=63f13d94&scoped=true&"
import script from "./SideNavBarQuestionLink.vue?vue&type=script&lang=js&"
export * from "./SideNavBarQuestionLink.vue?vue&type=script&lang=js&"
import style0 from "./SideNavBarQuestionLink.vue?vue&type=style&index=0&id=63f13d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f13d94",
  null
  
)

export default component.exports